import { useContext } from 'react';
import { context } from 'src/user/UserContext';

const useUserContext = () => useContext(context)
export default useUserContext
